export default {"src":"/login-app/[GIT_HASH]/_next/static/media/cost_yen.ad6f4db7.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};